<template>
  <div class="animated fadeIn">
    <div class="mt-5 display-4 text-left">
      <span>Edit Contact</span>
    </div>
    <div v-if="customer_contact && customer_contact.id">
      <b-card class="mt-3">
        <customer-contact-form-group
          :customer_contact="customer_contact"
          :disable_email="true"
          :no_email="true"
          :vuelidate="$v.customer_contact"
          @onCustomerContactChange="onCustomerContactChange"
        />
      </b-card>

      <b-alert show v-if="errorMsg" variant="danger">{{ errorMsg }}</b-alert>

      <div class="clearfix mb-2">
        <b-button variant="success" class="float-right" :disabled="submittingForm" @click="saveContact">
          <i v-if="submittingForm" class="fal fa-spinner fa-spin"></i>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>

    <div v-if="customer_contact && customer_contact.id">
      <h3>Update Email</h3>
      <b-card class="mt-3">
        <CustomerContactEmailForm
          :customer_contact_email="customer_contact_email"
          :vuelidate="$v.customer_contact_email"
          @onChange="onCustomerContactEmailChange"
        />
      </b-card>

      <b-alert show v-if="errorMsgEmailChange" variant="danger">{{ errorMsgEmailChange }}</b-alert>

      <div class="clearfix mb-5">
        <b-button variant="success" class="float-right" :disabled="requestingEmailChange" @click="requestEmailChange">
          <i v-if="requestingEmailChange" class="fal fa-spinner fa-spin"></i>
          <span v-else>Save</span>
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerContactFormGroup from '../../components/auth/register/inner/CustomerContactFormGroup'
import CustomerContactModel from '../../models/crm/CustomerContactModel'
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import CustomerContactEmailForm from '@/components/crm/customer/CustomerContactEmailForm'
import AuthRepository from '../../auth/AuthRepository'

export default {
  name: 'ContactEdit',
  components: { CustomerContactFormGroup, CustomerContactEmailForm },
  mixins: [validationMixin],
  data () {
    return {
      authenticated_customer_id: (this.$store.getters.getAuthCustomerID || null),
      id: (this.$route.params.id || null),
      customer_contact: null,
      customer_contact_email: null,

      errorMsg: null,
      submittingForm: false,

      errorMsgEmailChange: null,
      requestingEmailChange: false
    }
  },
  validations: {
    customer_contact: {
      first_name: {},
      last_name: {},
      phone_number: {},
      email: { required },
      role: {}
    },
    customer_contact_email: { required }
  },
  mounted () {
    if (this.id) {
      const customer_contact = new CustomerContactModel({ id: this.id })
      customer_contact.fetch().then(() => {
        if (customer_contact.customer_id === this.authenticated_customer_id) {
          this.customer_contact = customer_contact
          this.customer_contact_email = customer_contact.email
        } else {
          this.triggerContactNotFound()
        }
      }).catch(() => {
        this.triggerContactNotFound()
      })
    } else {
      this.triggerContactNotFound()
    }
  },
  methods: {
    onCustomerContactChange: function (customer_contact) {
      this.customer_contact.set(customer_contact)
    },
    
    onCustomerContactEmailChange (customer_contact_email) {
      this.customer_contact_email = customer_contact_email
    },

    saveContact: function () {
      this.errorMsg = null
      this.submittingForm = true

      this.customer_contact.set('customer_id', this.authenticated_customer_id)
      this.customer_contact.save().then(() => {
        this.$bvToast.toast('Thanks!', {
          title: 'Contact updated successfully',
          variant: 'success',
          autoHideDelay: 1000
        })
        setTimeout(() => { this.$router.push('/team') }, 1000)
      }).catch((err) => {
        this.submittingForm = false

        if (err.response && err.response.data && err.response.data.message) {
          this.errorMsg = err.response.data.message
        } else {
          this.errorMsg = 'Something went wrong please contact an administrator'
        }
      })
    },

    triggerContactNotFound (msg) {
      this.$bvToast.toast((msg || 'The contact you were trying to update could not be found in our system.'), {
        title: 'Contact not found',
        variant: 'warning'
      })
    },

    requestEmailChange () {
      this.errorMsgEmailChange = null
      this.requestingEmailChange = true

      AuthRepository.updateEmailRequest(this.customer_contact_email).then(() => {
        this.$bvToast.toast('Thanks!', {
          title: 'Email change request sent successfully',
          variant: 'success',
          autoHideDelay: 1000
        })
        setTimeout(() => { this.$router.push('/confirm-email-change') }, 1000)
      }).catch((err) => {
        this.requestingEmailChange = false

        if (err.response && err.response.data && err.response.data.message) {
          this.errorMsgEmailChange = err.response.data.message
        } else {
          this.errorMsgEmailChange = 'Something went wrong please contact an administrator'
        }
      })
    }

  }
}
</script>
